import React from 'react';
import './styles.scss';

interface Props {
  id: string,
  name: string,
  onClick: (e: React.MouseEvent, id: string) => void,
  isSelected: boolean
}


const BookmarkInfoComponent: React.FC<Props> = ({id, name, onClick, isSelected}) => {
  return <div key={id}
              className={`bookmark ${isSelected ? 'selected' : ''}`}
              onClick={(e) => onClick(e, id)}
  >
    <div className="bookmark__name">{name}</div>
  </div>
}

export default BookmarkInfoComponent;